import gql from 'graphql-tag';

export default gql`
  mutation RemoveMealMutation($mealId: Int!) {
    dailyTracker {
      removeMeal(mealId: $mealId) {
        ... on BasicMutationSuccess {
          code
        }
        ... on Error {
          errorCode: code
          name
          description
        }
        ... on UnauthorizedException {
          authCode: code
        }
      }
    }
  }
`;
